import { SVGProps } from 'react'

interface GithubSVGProps extends SVGProps<SVGSVGElement> {
  size?: number
}

const GithubSvg = ({ size = 24, ...props }: GithubSVGProps) => {
  return (
    <svg
      fill='currentColor'
      stroke='currentColor'
      width={size}
      height={size}
      viewBox='0 0 20 20'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M94 7399c5.523 0 10 4.59 10 10.253 0 4.529-2.862 8.371-6.833 9.728-.507.101-.687-.219-.687-.492 0-.338.012-1.442.012-2.814 0-.956-.32-1.58-.679-1.898 2.227-.254 4.567-1.121 4.567-5.059 0-1.12-.388-2.034-1.03-2.752.104-.259.447-1.302-.098-2.714 0 0-.838-.275-2.747 1.051a9.396 9.396 0 00-2.505-.345 9.375 9.375 0 00-2.503.345c-1.911-1.326-2.751-1.051-2.751-1.051-.543 1.412-.2 2.455-.097 2.714-.639.718-1.03 1.632-1.03 2.752 0 3.928 2.335 4.808 4.556 5.067-.286.256-.545.708-.635 1.371-.57.262-2.018.715-2.91-.852 0 0-.529-.985-1.533-1.057 0 0-.975-.013-.068.623 0 0 .655.315 1.11 1.5 0 0 .587 1.83 3.369 1.21.005.857.014 1.665.014 1.909 0 .271-.184.588-.683.493-3.974-1.355-6.839-5.199-6.839-9.729 0-5.663 4.478-10.253 10-10.253'
        transform='translate(-140 -7559) translate(56 160)'
        fill='currentColor'
        stroke='none'
        strokeWidth={1}
        fillRule='evenodd'
      />
    </svg>
  )
}

export default GithubSvg
